import { UsageNameToCodeEnum } from '@ecm/portfolio';

export const carrouselTranslation = {
    carrousel: {
        default: {
            avatarSrc: 'https://proxymedia.woopic.com/api/v1/images/1211%2Favatars%2F0.png',
            avatarAlt: 'Icone par défaut',
            link: {
                inApp: 'accueil',
            },
        },
        parnasse: {
            avatarSrc: 'https://proxymedia.woopic.com/api/v1/images/1202%2Fparnasse.png',
            avatarAlt: 'Icone client parnasse',
            label: 'Parnasse',
        },
        maison_protegee: {
            avatarSrc: 'https://proxymedia.woopic.com/api/v1/images/1202%2Fmaison_protegee.png',
            avatarAlt: 'Icone client maison protégée',
            label: 'Maison Protégée',
        },
        maison_protegee_2: {
            avatarSrc: 'https://proxymedia.woopic.com/api/v1/images/1202%2Fsurveillance-maison-protegee.png',
            avatarAlt: 'Icone client maison protégée',
            label: 'Orange Maison Protégée',
        },
        obs: {
            avatarSrc: 'https://proxymedia.woopic.com/api/v1/images/1202%2Forange_entreprise.png',
            avatarAlt: 'Icone client OBS',
            label: 'Orange Business Lounge',
        },
        pro: {
            avatarSrc: 'https://proxymedia.woopic.com/api/v1/images/1202%2Forange_pro.png',
            avatarAlt: 'Icone client PRO',
            label: 'Orange Pro',
        },
        carte_prepayee: {
            avatarSrc: 'https://proxymedia.woopic.com/api/v1/images/1211%2Favatars%2F0.png',
            avatarAlt: 'Icone par défaut',
            label: 'Carte Prépayée',
        },
        fixe: {
            avatarSrc: 'https://proxymedia.woopic.com/api/v1/images/1211%2Favatars%2F0.png',
            avatarAlt: 'Icone par défaut',
            link: {
                inApp: 'accueil',
            },
        },
        addMember: {
            avatarSrc: 'https://proxymedia.woopic.com/api/v1/images/1202%2Fgerer_profils.png',
            avatarAlt: 'Icone gérer vos profils',
            label: 'Gérer vos profils',
            link: {
                inApp: '/compte/gerer-profils',
            },
            isAddMember: true,
        },
        manageAccount: {
            link: {
                inApp: 'compte',
            },
            label: 'Gérer votre compte',
        },
        avantagesClient: {
            link: {
                inApp: 'offre-options/avantages-multicontrats',
            },
            label: 'Vos avantages client',
        },
        orangeServices: {
            link: {
                browser: 'https://service.orange.fr/',
            },
            label: 'Vos services Orange',
        },
    },
    openLinks: {
        PERSONAL_INFO: {
            link: {
                inApp: '/compte',
            },
            label: 'Infos personnelles',
            status: false,
        },
        PROFILS: {
            link: {
                inApp: '/compte/gerer-profils',
            },
            label: 'Gérer vos profils',
            status: false,
        },
        DOCUMENTS: {
            link: {
                inApp: '/contrat/mes-documents?backRoute=%2Fcompte',
            },
            label: 'Documents contractuels',
            status: false,
        },
        TRACKINGDELIVERY: {
            link: {
                browser: 'https://suivi.orange.fr',
            },
            label: 'Suivi de commande',
            status: false,
        },
        CONTACT: {
            link: {
                inApp: '/compte/contact-demarches',
            },
            label: 'Contact et démarches',
            icon: 'icon-orange-info',
            status: false,
        },
    },
    openLinkSosh: {
        PERSONAL_INFO: {
            link: {
                inApp: '/compte',
            },
            label: 'Infos personnelles',
            status: false,
        },
        PROFILS: {
            link: {
                inApp: '/compte/gerer-profils',
            },
            label: 'Gérer vos profils',
            status: false,
        },
        DOCUMENTS: {
            link: {
                inApp: '/contrat/mes-documents?backRoute=%2Fcompte',
            },
            label: 'Documents contractuels',
            status: false,
        },
        TRACKINGDELIVERY: {
            link: {
                browser: 'https://suivi.orange.fr?sosh=y',
            },
            label: 'Suivi de commande',
            status: false,
        },
        CONTACT: {
            link: {
                inApp: '/compte/suivi-demarches',
            },
            label: 'Contact et démarches',
            icon: 'icon-orange-info',
            status: false,
        },
    },
    flagLinks: {
        AVANTAGES_CLIENT: {
            link: {
                inApp: '/offre-options/avantages-multicontrats',
            },
            label: 'Avantages client',
            icon: 'icon-heart-advantages',
        },
        ORANGE_SERVICES: {
            link: {
                browser: 'https://service.orange.fr/',
            },
            label: 'Les engagements <span lang="en">On</span>',
        },
        ORANGE_FIDELITE: {
            link: {
                inApp: '/avantages',
            },
            label: 'Orange Fidélité',
        },
    },
    navigations: {
        FACTURES: {
            url: 'facture-paiement/{{cid}}',
            label: 'Factures',
        },
        OFFRE_OPTIONS: {
            url: 'offre-options/{{cid}}',
            label: 'Offre et options',
        },
        LIVEBOX: {
            url: 'equipements/{{cid}}/{{usageCode}}/internet',
            label: 'Livebox',
            usageCode: [UsageNameToCodeEnum.livebox],
        },
        TV: {
            url: 'equipements/{{cid}}/tv',
            label: 'TV',
            usageCode: [UsageNameToCodeEnum.tv],
        },
        MOBILE: {
            url: 'equipements/{{cid}}/{{usageCode}}/mobile',
            label: 'Mobile',
            usageCode: [UsageNameToCodeEnum.mobile],
        },
        SIM: {
            url: 'equipements/{{cid}}/{{usageCode}}/tablette-cle',
            label: 'Clé internet/tablette',
            usageCode: [UsageNameToCodeEnum.sim],
        },
        VOIP: {
            url: 'equipements/{{cid}}/{{usageCode}}/tel-voip',
            label: 'Ligne fixe',
            usageCode: [UsageNameToCodeEnum.voipH323, UsageNameToCodeEnum.voipLandline, UsageNameToCodeEnum.voipSip],
        },
        LANDLINE: {
            url: 'equipements/{{cid}}/{{usageCode}}/tel-fixe',
            label: 'Ligne fixe',
            usageCode: [
                UsageNameToCodeEnum.Landline,
                UsageNameToCodeEnum.LandlineCorps,
                UsageNameToCodeEnum.LandlinePrincipal,
            ],
        },
        FLYBOX: {
            url: 'equipements/{{cid}}/{{usageCode}}/flybox',
            label: 'Flybox',
            usageCode: [UsageNameToCodeEnum.flybox],
        },
        AIRBOX: {
            url: 'equipements/{{cid}}/{{usageCode}}/airbox',
            label: 'Airbox',
            usageCode: [UsageNameToCodeEnum.airbox],
        },
        SMARTWATCH: {
            url: 'equipements/{{cid}}/{{usageCode}}/montre-connectee',
            label: 'Montre connectée',
            usageCode: [UsageNameToCodeEnum.smartWatch],
        },
        MULTISIMI: {
            url: 'equipements/{{cid}}/{{usageCode}}/multisim',
            label: 'Multi-SIM',
            usageCode: [UsageNameToCodeEnum.multiSimI],
        },
        MULTISIMIA: {
            url: 'equipements/{{cid}}/{{usageCode}}/multisim',
            label: 'Multi-SIM',
            usageCode: [UsageNameToCodeEnum.multiSimIA],
        },
        CYBERSECURITY: {
            label: 'Cybersécurité',
            url: '/offre-options/{{cid}}/cybersecure',
            usageCode: [UsageNameToCodeEnum.cybersecure],
        },
    },
    details: {
        synthese: 'Synthèse',
        who_uses_it: {
            url: '/compte/association-contrat/{{cid}}',
            label: 'Qui utilise ce contrat ?',
        },
        profile: {
            url: '/compte/profil/',
        },
        gerer_profils: {
            url: '/compte/gerer-profils/',
        },
        sharedServices: 'Services partagés',
    },
};
